import React from 'react'
import {Header, List} from 'semantic-ui-react'

const ShareMockDocsLink = () => {
  return (
    <div className='doc-section'>
      <Header as='h2'>Share Mock Docs Link</Header>
      <Header as='h3' dividing>Steps:</Header>
      <List relaxed>
        <List.Item>1. Navigate to the service/version you wish to work with.</List.Item>
        <List.Item>2. Click on the "Docs" tab</List.Item>
        <List.Item>3. Find the environment you wish to publish docs for in the table listed.</List.Item>
        <List.Item>4. Choose "as swagger docs" or "as api docs" from the drop down</List.Item>
        <List.Item>5. (Optionally) toggle the Ref. Mock on if you want the docs to refer to that env's mock url.</List.Item>
        <List.Item>6. (Optionally) preview to ensure they reflect your latest contract definition.</List.Item>
        <List.Item>7. Click "View" button to open link to the docs.</List.Item>
        <List.Item>8. Share this link with others as necessary</List.Item>
        <List.Item></List.Item>
      </List>
    </div>
  )
}

export {ShareMockDocsLink}

export default ShareMockDocsLink